module.exports = __webpack_public_path__ + "img/lcc1.1700788f.png";